<template>
           <div class="gotop"  v-if="showgo">
				<div class="gotopup" :class="{'dark':themeName=='dark'}" @click="gotop"><i class="iconfont icon-dingbu"></i></div>
				<div class="gotobottom" :class="{'dark':themeName=='dark'}" @click="gobottom"><i class="iconfont icon-dingbu"></i></div>
			</div>
</template>
<script>
	  
export default {
  name: 'GoTop',
  data() {
  	return {
  		showgo: false
  	}
  },
  mounted() {
  	var vm = this;
	
  window.addEventListener('scroll',()=>{
  		 if (window.scrollY > 100) {
  		 	vm.showgo = true;
  		 } else {
  		 	vm.showgo = false;
  		 }
  		 
  		 // console.log(window.scrollY)
  		  })
   
  },
 
  methods: {
 
	  
  	gotop: function() {
  		scrollTo(0, 0);
  	},
  	gobottom: function() {
  		scrollTo(0, document.documentElement.scrollHeight);
  	},
  },
}
</script>
<style>
	.gotop {
		position: fixed;
		right: 10vw;
		bottom: 30vh;
		cursor: pointer;
	}
	.gotopup.dark{
		color: #808080;
	}

	.gotopup {
		width: 9vw;
		height: 9vw;
		 
		line-height: 9vw;
		text-align: center;
		font-size: 6vw;
		font-weight: bold;
		background-color: rgba(0, 0, 0, .2);
		color: #fff;
	}
	.gotobottom {
		width: 9vw;
		height: 9vw;
		transform: rotate(180deg); 
		line-height: 9vw;
		text-align: center;
		font-size: 6vw;
		font-weight: bold;
		background-color: rgba(0, 0, 0, .2);
		color: #fff;
	}
	.gotobottom.dark{
		color: #808080;
	}
</style>
 